function cov_wb038vf15() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Select/useSelectStyles.ts";
  var hash = "b0882a676f92518b03a15835930a6c1dbeb12d30";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Select/useSelectStyles.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 23
        },
        end: {
          line: 10,
          column: 1
        }
      },
      "1": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 7,
          column: 3
        }
      },
      "2": {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 35
        }
      },
      "3": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 34
        }
      },
      "4": {
        start: {
          line: 12,
          column: 23
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "5": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "6": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 30
        }
      },
      "7": {
        start: {
          line: 20,
          column: 9
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "8": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 36
        }
      },
      "9": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 23,
          column: 33
        }
      },
      "10": {
        start: {
          line: 26,
          column: 27
        },
        end: {
          line: 37,
          column: 1
        }
      },
      "11": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 35,
          column: 3
        }
      },
      "12": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 35
        }
      },
      "13": {
        start: {
          line: 33,
          column: 9
        },
        end: {
          line: 35,
          column: 3
        }
      },
      "14": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 35
        }
      },
      "15": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 36,
          column: 32
        }
      },
      "16": {
        start: {
          line: 39,
          column: 18
        },
        end: {
          line: 45,
          column: 1
        }
      },
      "17": {
        start: {
          line: 40,
          column: 25
        },
        end: {
          line: 40,
          column: 57
        }
      },
      "18": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 44,
          column: 4
        }
      },
      "19": {
        start: {
          line: 47,
          column: 24
        },
        end: {
          line: 55,
          column: 2
        }
      },
      "20": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 55,
          column: 1
        }
      },
      "21": {
        start: {
          line: 57,
          column: 30
        },
        end: {
          line: 65,
          column: 2
        }
      },
      "22": {
        start: {
          line: 57,
          column: 42
        },
        end: {
          line: 65,
          column: 1
        }
      },
      "23": {
        start: {
          line: 67,
          column: 30
        },
        end: {
          line: 71,
          column: 2
        }
      },
      "24": {
        start: {
          line: 67,
          column: 56
        },
        end: {
          line: 71,
          column: 1
        }
      },
      "25": {
        start: {
          line: 73,
          column: 31
        },
        end: {
          line: 91,
          column: 1
        }
      },
      "26": {
        start: {
          line: 80,
          column: 20
        },
        end: {
          line: 80,
          column: 73
        }
      },
      "27": {
        start: {
          line: 81,
          column: 2
        },
        end: {
          line: 90,
          column: 4
        }
      },
      "28": {
        start: {
          line: 93,
          column: 28
        },
        end: {
          line: 108,
          column: 1
        }
      },
      "29": {
        start: {
          line: 94,
          column: 2
        },
        end: {
          line: 99,
          column: 3
        }
      },
      "30": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 98,
          column: 6
        }
      },
      "31": {
        start: {
          line: 101,
          column: 2
        },
        end: {
          line: 107,
          column: 4
        }
      },
      "32": {
        start: {
          line: 110,
          column: 28
        },
        end: {
          line: 130,
          column: 1
        }
      },
      "33": {
        start: {
          line: 115,
          column: 2
        },
        end: {
          line: 125,
          column: 3
        }
      },
      "34": {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 119,
          column: 6
        }
      },
      "35": {
        start: {
          line: 120,
          column: 9
        },
        end: {
          line: 125,
          column: 3
        }
      },
      "36": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 124,
          column: 6
        }
      },
      "37": {
        start: {
          line: 127,
          column: 2
        },
        end: {
          line: 129,
          column: 4
        }
      },
      "38": {
        start: {
          line: 132,
          column: 30
        },
        end: {
          line: 150,
          column: 1
        }
      },
      "39": {
        start: {
          line: 136,
          column: 2
        },
        end: {
          line: 143,
          column: 3
        }
      },
      "40": {
        start: {
          line: 137,
          column: 4
        },
        end: {
          line: 142,
          column: 6
        }
      },
      "41": {
        start: {
          line: 145,
          column: 2
        },
        end: {
          line: 149,
          column: 4
        }
      },
      "42": {
        start: {
          line: 152,
          column: 31
        },
        end: {
          line: 265,
          column: 1
        }
      },
      "43": {
        start: {
          line: 153,
          column: 16
        },
        end: {
          line: 153,
          column: 42
        }
      },
      "44": {
        start: {
          line: 154,
          column: 2
        },
        end: {
          line: 264,
          column: 5
        }
      },
      "45": {
        start: {
          line: 159,
          column: 8
        },
        end: {
          line: 264,
          column: 3
        }
      },
      "46": {
        start: {
          line: 160,
          column: 33
        },
        end: {
          line: 164,
          column: 5
        }
      },
      "47": {
        start: {
          line: 166,
          column: 6
        },
        end: {
          line: 175,
          column: 8
        }
      },
      "48": {
        start: {
          line: 177,
          column: 41
        },
        end: {
          line: 181,
          column: 5
        }
      },
      "49": {
        start: {
          line: 182,
          column: 38
        },
        end: {
          line: 186,
          column: 5
        }
      },
      "50": {
        start: {
          line: 187,
          column: 28
        },
        end: {
          line: 195,
          column: 5
        }
      },
      "51": {
        start: {
          line: 196,
          column: 25
        },
        end: {
          line: 199,
          column: 5
        }
      },
      "52": {
        start: {
          line: 200,
          column: 30
        },
        end: {
          line: 210,
          column: 5
        }
      },
      "53": {
        start: {
          line: 211,
          column: 35
        },
        end: {
          line: 217,
          column: 5
        }
      },
      "54": {
        start: {
          line: 220,
          column: 35
        },
        end: {
          line: 224,
          column: 5
        }
      },
      "55": {
        start: {
          line: 227,
          column: 34
        },
        end: {
          line: 237,
          column: 5
        }
      },
      "56": {
        start: {
          line: 238,
          column: 39
        },
        end: {
          line: 245,
          column: 5
        }
      },
      "57": {
        start: {
          line: 246,
          column: 40
        },
        end: {
          line: 258,
          column: 5
        }
      },
      "58": {
        start: {
          line: 259,
          column: 42
        },
        end: {
          line: 263,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 23
          },
          end: {
            line: 4,
            column: 24
          }
        },
        loc: {
          start: {
            line: 4,
            column: 68
          },
          end: {
            line: 10,
            column: 1
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 23
          },
          end: {
            line: 12,
            column: 24
          }
        },
        loc: {
          start: {
            line: 17,
            column: 5
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 17
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 26,
            column: 27
          },
          end: {
            line: 26,
            column: 28
          }
        },
        loc: {
          start: {
            line: 30,
            column: 5
          },
          end: {
            line: 37,
            column: 1
          }
        },
        line: 30
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 39,
            column: 18
          },
          end: {
            line: 39,
            column: 19
          }
        },
        loc: {
          start: {
            line: 39,
            column: 86
          },
          end: {
            line: 45,
            column: 1
          }
        },
        line: 39
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 47,
            column: 24
          },
          end: {
            line: 47,
            column: 25
          }
        },
        loc: {
          start: {
            line: 52,
            column: 6
          },
          end: {
            line: 55,
            column: 1
          }
        },
        line: 52
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 57,
            column: 30
          },
          end: {
            line: 57,
            column: 31
          }
        },
        loc: {
          start: {
            line: 57,
            column: 42
          },
          end: {
            line: 65,
            column: 1
          }
        },
        line: 57
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 67,
            column: 30
          },
          end: {
            line: 67,
            column: 31
          }
        },
        loc: {
          start: {
            line: 67,
            column: 56
          },
          end: {
            line: 71,
            column: 1
          }
        },
        line: 67
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 73,
            column: 31
          },
          end: {
            line: 73,
            column: 32
          }
        },
        loc: {
          start: {
            line: 79,
            column: 5
          },
          end: {
            line: 91,
            column: 1
          }
        },
        line: 79
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 93,
            column: 28
          },
          end: {
            line: 93,
            column: 29
          }
        },
        loc: {
          start: {
            line: 93,
            column: 99
          },
          end: {
            line: 108,
            column: 1
          }
        },
        line: 93
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 110,
            column: 28
          },
          end: {
            line: 110,
            column: 29
          }
        },
        loc: {
          start: {
            line: 114,
            column: 5
          },
          end: {
            line: 130,
            column: 1
          }
        },
        line: 114
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 132,
            column: 30
          },
          end: {
            line: 132,
            column: 31
          }
        },
        loc: {
          start: {
            line: 135,
            column: 5
          },
          end: {
            line: 150,
            column: 1
          }
        },
        line: 135
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 152,
            column: 31
          },
          end: {
            line: 152,
            column: 32
          }
        },
        loc: {
          start: {
            line: 152,
            column: 37
          },
          end: {
            line: 265,
            column: 1
          }
        },
        line: 152
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 154,
            column: 9
          },
          end: {
            line: 154,
            column: 10
          }
        },
        loc: {
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 264,
            column: 3
          }
        },
        line: 159
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 160,
            column: 15
          },
          end: {
            line: 160,
            column: 16
          }
        },
        loc: {
          start: {
            line: 160,
            column: 33
          },
          end: {
            line: 164,
            column: 5
          }
        },
        line: 160
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 165,
            column: 13
          },
          end: {
            line: 165,
            column: 14
          }
        },
        loc: {
          start: {
            line: 165,
            column: 30
          },
          end: {
            line: 176,
            column: 5
          }
        },
        line: 165
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 177,
            column: 23
          },
          end: {
            line: 177,
            column: 24
          }
        },
        loc: {
          start: {
            line: 177,
            column: 41
          },
          end: {
            line: 181,
            column: 5
          }
        },
        line: 177
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 182,
            column: 20
          },
          end: {
            line: 182,
            column: 21
          }
        },
        loc: {
          start: {
            line: 182,
            column: 38
          },
          end: {
            line: 186,
            column: 5
          }
        },
        line: 182
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 187,
            column: 10
          },
          end: {
            line: 187,
            column: 11
          }
        },
        loc: {
          start: {
            line: 187,
            column: 28
          },
          end: {
            line: 195,
            column: 5
          }
        },
        line: 187
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 196,
            column: 14
          },
          end: {
            line: 196,
            column: 15
          }
        },
        loc: {
          start: {
            line: 196,
            column: 25
          },
          end: {
            line: 199,
            column: 5
          }
        },
        line: 196
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 200,
            column: 12
          },
          end: {
            line: 200,
            column: 13
          }
        },
        loc: {
          start: {
            line: 200,
            column: 30
          },
          end: {
            line: 210,
            column: 5
          }
        },
        line: 200
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 211,
            column: 17
          },
          end: {
            line: 211,
            column: 18
          }
        },
        loc: {
          start: {
            line: 211,
            column: 35
          },
          end: {
            line: 217,
            column: 5
          }
        },
        line: 211
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 220,
            column: 17
          },
          end: {
            line: 220,
            column: 18
          }
        },
        loc: {
          start: {
            line: 220,
            column: 35
          },
          end: {
            line: 224,
            column: 5
          }
        },
        line: 220
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 227,
            column: 16
          },
          end: {
            line: 227,
            column: 17
          }
        },
        loc: {
          start: {
            line: 227,
            column: 34
          },
          end: {
            line: 237,
            column: 5
          }
        },
        line: 227
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 238,
            column: 21
          },
          end: {
            line: 238,
            column: 22
          }
        },
        loc: {
          start: {
            line: 238,
            column: 39
          },
          end: {
            line: 245,
            column: 5
          }
        },
        line: 238
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 246,
            column: 22
          },
          end: {
            line: 246,
            column: 23
          }
        },
        loc: {
          start: {
            line: 246,
            column: 40
          },
          end: {
            line: 258,
            column: 5
          }
        },
        line: 246
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 259,
            column: 24
          },
          end: {
            line: 259,
            column: 25
          }
        },
        loc: {
          start: {
            line: 259,
            column: 42
          },
          end: {
            line: 263,
            column: 5
          }
        },
        line: 259
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 7,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 7,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 5
      },
      "1": {
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        }, {
          start: {
            line: 20,
            column: 9
          },
          end: {
            line: 22,
            column: 3
          }
        }],
        line: 18
      },
      "2": {
        loc: {
          start: {
            line: 20,
            column: 9
          },
          end: {
            line: 22,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 9
          },
          end: {
            line: 22,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 20
      },
      "3": {
        loc: {
          start: {
            line: 20,
            column: 13
          },
          end: {
            line: 20,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 14
          },
          end: {
            line: 20,
            column: 29
          }
        }, {
          start: {
            line: 20,
            column: 33
          },
          end: {
            line: 20,
            column: 50
          }
        }, {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 20,
            column: 75
          }
        }, {
          start: {
            line: 20,
            column: 79
          },
          end: {
            line: 20,
            column: 96
          }
        }],
        line: 20
      },
      "4": {
        loc: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        }, {
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 35,
            column: 3
          }
        }],
        line: 31
      },
      "5": {
        loc: {
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 35,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 35,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 33
      },
      "6": {
        loc: {
          start: {
            line: 33,
            column: 13
          },
          end: {
            line: 33,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 13
          },
          end: {
            line: 33,
            column: 28
          }
        }, {
          start: {
            line: 33,
            column: 32
          },
          end: {
            line: 33,
            column: 51
          }
        }],
        line: 33
      },
      "7": {
        loc: {
          start: {
            line: 42,
            column: 12
          },
          end: {
            line: 42,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 42,
            column: 22
          },
          end: {
            line: 42,
            column: 28
          }
        }, {
          start: {
            line: 42,
            column: 31
          },
          end: {
            line: 42,
            column: 54
          }
        }],
        line: 42
      },
      "8": {
        loc: {
          start: {
            line: 43,
            column: 15
          },
          end: {
            line: 43,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 43,
            column: 25
          },
          end: {
            line: 43,
            column: 31
          }
        }, {
          start: {
            line: 43,
            column: 34
          },
          end: {
            line: 43,
            column: 41
          }
        }],
        line: 43
      },
      "9": {
        loc: {
          start: {
            line: 80,
            column: 20
          },
          end: {
            line: 80,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 80,
            column: 42
          },
          end: {
            line: 80,
            column: 56
          }
        }, {
          start: {
            line: 80,
            column: 59
          },
          end: {
            line: 80,
            column: 73
          }
        }],
        line: 80
      },
      "10": {
        loc: {
          start: {
            line: 82,
            column: 13
          },
          end: {
            line: 82,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 82,
            column: 39
          },
          end: {
            line: 82,
            column: 40
          }
        }, {
          start: {
            line: 82,
            column: 43
          },
          end: {
            line: 82,
            column: 75
          }
        }],
        line: 82
      },
      "11": {
        loc: {
          start: {
            line: 83,
            column: 15
          },
          end: {
            line: 83,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 83,
            column: 37
          },
          end: {
            line: 83,
            column: 45
          }
        }, {
          start: {
            line: 83,
            column: 48
          },
          end: {
            line: 83,
            column: 57
          }
        }],
        line: 83
      },
      "12": {
        loc: {
          start: {
            line: 86,
            column: 19
          },
          end: {
            line: 86,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 86,
            column: 31
          },
          end: {
            line: 86,
            column: 49
          }
        }, {
          start: {
            line: 86,
            column: 52
          },
          end: {
            line: 86,
            column: 76
          }
        }],
        line: 86
      },
      "13": {
        loc: {
          start: {
            line: 94,
            column: 2
          },
          end: {
            line: 99,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 2
          },
          end: {
            line: 99,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 94
      },
      "14": {
        loc: {
          start: {
            line: 115,
            column: 2
          },
          end: {
            line: 125,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 2
          },
          end: {
            line: 125,
            column: 3
          }
        }, {
          start: {
            line: 120,
            column: 9
          },
          end: {
            line: 125,
            column: 3
          }
        }],
        line: 115
      },
      "15": {
        loc: {
          start: {
            line: 118,
            column: 18
          },
          end: {
            line: 118,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 118,
            column: 40
          },
          end: {
            line: 118,
            column: 66
          }
        }, {
          start: {
            line: 118,
            column: 69
          },
          end: {
            line: 118,
            column: 93
          }
        }],
        line: 118
      },
      "16": {
        loc: {
          start: {
            line: 120,
            column: 9
          },
          end: {
            line: 125,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 120,
            column: 9
          },
          end: {
            line: 125,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 120
      },
      "17": {
        loc: {
          start: {
            line: 136,
            column: 2
          },
          end: {
            line: 143,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 136,
            column: 2
          },
          end: {
            line: 143,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 136
      },
      "18": {
        loc: {
          start: {
            line: 163,
            column: 10
          },
          end: {
            line: 163,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 163,
            column: 33
          },
          end: {
            line: 163,
            column: 59
          }
        }, {
          start: {
            line: 163,
            column: 62
          },
          end: {
            line: 163,
            column: 64
          }
        }],
        line: 163
      },
      "19": {
        loc: {
          start: {
            line: 174,
            column: 12
          },
          end: {
            line: 174,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 174,
            column: 33
          },
          end: {
            line: 174,
            column: 57
          }
        }, {
          start: {
            line: 174,
            column: 60
          },
          end: {
            line: 174,
            column: 62
          }
        }],
        line: 174
      },
      "20": {
        loc: {
          start: {
            line: 180,
            column: 10
          },
          end: {
            line: 180,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 180,
            column: 41
          },
          end: {
            line: 180,
            column: 75
          }
        }, {
          start: {
            line: 180,
            column: 78
          },
          end: {
            line: 180,
            column: 80
          }
        }],
        line: 180
      },
      "21": {
        loc: {
          start: {
            line: 185,
            column: 10
          },
          end: {
            line: 185,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 185,
            column: 38
          },
          end: {
            line: 185,
            column: 69
          }
        }, {
          start: {
            line: 185,
            column: 72
          },
          end: {
            line: 185,
            column: 74
          }
        }],
        line: 185
      },
      "22": {
        loc: {
          start: {
            line: 190,
            column: 27
          },
          end: {
            line: 190,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 190,
            column: 39
          },
          end: {
            line: 190,
            column: 57
          }
        }, {
          start: {
            line: 190,
            column: 60
          },
          end: {
            line: 190,
            column: 84
          }
        }],
        line: 190
      },
      "23": {
        loc: {
          start: {
            line: 194,
            column: 10
          },
          end: {
            line: 194,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 194,
            column: 28
          },
          end: {
            line: 194,
            column: 49
          }
        }, {
          start: {
            line: 194,
            column: 52
          },
          end: {
            line: 194,
            column: 54
          }
        }],
        line: 194
      },
      "24": {
        loc: {
          start: {
            line: 198,
            column: 10
          },
          end: {
            line: 198,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 198,
            column: 32
          },
          end: {
            line: 198,
            column: 50
          }
        }, {
          start: {
            line: 198,
            column: 53
          },
          end: {
            line: 198,
            column: 55
          }
        }],
        line: 198
      },
      "25": {
        loc: {
          start: {
            line: 205,
            column: 26
          },
          end: {
            line: 205,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 205,
            column: 44
          },
          end: {
            line: 205,
            column: 67
          }
        }, {
          start: {
            line: 205,
            column: 70
          },
          end: {
            line: 205,
            column: 94
          }
        }],
        line: 205
      },
      "26": {
        loc: {
          start: {
            line: 209,
            column: 10
          },
          end: {
            line: 209,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 209,
            column: 30
          },
          end: {
            line: 209,
            column: 53
          }
        }, {
          start: {
            line: 209,
            column: 56
          },
          end: {
            line: 209,
            column: 58
          }
        }],
        line: 209
      },
      "27": {
        loc: {
          start: {
            line: 216,
            column: 10
          },
          end: {
            line: 216,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 216,
            column: 35
          },
          end: {
            line: 216,
            column: 63
          }
        }, {
          start: {
            line: 216,
            column: 66
          },
          end: {
            line: 216,
            column: 68
          }
        }],
        line: 216
      },
      "28": {
        loc: {
          start: {
            line: 223,
            column: 10
          },
          end: {
            line: 223,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 223,
            column: 35
          },
          end: {
            line: 223,
            column: 63
          }
        }, {
          start: {
            line: 223,
            column: 66
          },
          end: {
            line: 223,
            column: 68
          }
        }],
        line: 223
      },
      "29": {
        loc: {
          start: {
            line: 236,
            column: 10
          },
          end: {
            line: 236,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 236,
            column: 34
          },
          end: {
            line: 236,
            column: 61
          }
        }, {
          start: {
            line: 236,
            column: 64
          },
          end: {
            line: 236,
            column: 66
          }
        }],
        line: 236
      },
      "30": {
        loc: {
          start: {
            line: 244,
            column: 10
          },
          end: {
            line: 244,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 244,
            column: 39
          },
          end: {
            line: 244,
            column: 71
          }
        }, {
          start: {
            line: 244,
            column: 74
          },
          end: {
            line: 244,
            column: 76
          }
        }],
        line: 244
      },
      "31": {
        loc: {
          start: {
            line: 257,
            column: 10
          },
          end: {
            line: 257,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 257,
            column: 40
          },
          end: {
            line: 257,
            column: 73
          }
        }, {
          start: {
            line: 257,
            column: 76
          },
          end: {
            line: 257,
            column: 78
          }
        }],
        line: 257
      },
      "32": {
        loc: {
          start: {
            line: 262,
            column: 10
          },
          end: {
            line: 262,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 262,
            column: 42
          },
          end: {
            line: 262,
            column: 77
          }
        }, {
          start: {
            line: 262,
            column: 80
          },
          end: {
            line: 262,
            column: 82
          }
        }],
        line: 262
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b0882a676f92518b03a15835930a6c1dbeb12d30"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_wb038vf15 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_wb038vf15();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useTheme } from "../../system/theme/index.mjs";
cov_wb038vf15().s[0]++;
const getOptionColor = (theme, state) => {
  cov_wb038vf15().f[0]++;
  cov_wb038vf15().s[1]++;
  if (state.isDisabled) {
    cov_wb038vf15().b[0][0]++;
    cov_wb038vf15().s[2]++;
    return theme.colors.neutrals70;
  } else {
    cov_wb038vf15().b[0][1]++;
  }
  cov_wb038vf15().s[3]++;
  return theme.colors.neutrals100;
};
cov_wb038vf15().s[4]++;
const getBorderColor = (theme, isInvalid, state, variant) => {
  cov_wb038vf15().f[1]++;
  cov_wb038vf15().s[5]++;
  if (isInvalid) {
    cov_wb038vf15().b[1][0]++;
    cov_wb038vf15().s[6]++;
    return theme.colors.red50;
  } else {
    cov_wb038vf15().b[1][1]++;
    cov_wb038vf15().s[7]++;
    if ((cov_wb038vf15().b[3][0]++, state.isFocused) && (cov_wb038vf15().b[3][1]++, !state.isDisabled) || (cov_wb038vf15().b[3][2]++, variant === 'small') && (cov_wb038vf15().b[3][3]++, !state.isDisabled)) {
      cov_wb038vf15().b[2][0]++;
      cov_wb038vf15().s[8]++;
      return theme.colors.neutrals100;
    } else {
      cov_wb038vf15().b[2][1]++;
    }
  }
  cov_wb038vf15().s[9]++;
  return theme.colors.neutrals40;
};
cov_wb038vf15().s[10]++;
const getBackgroundColor = (theme, state, variant) => {
  cov_wb038vf15().f[2]++;
  cov_wb038vf15().s[11]++;
  if (state.isDisabled) {
    cov_wb038vf15().b[4][0]++;
    cov_wb038vf15().s[12]++;
    return theme.colors.neutrals30;
  } else {
    cov_wb038vf15().b[4][1]++;
    cov_wb038vf15().s[13]++;
    if ((cov_wb038vf15().b[6][0]++, state.isFocused) && (cov_wb038vf15().b[6][1]++, variant === 'small')) {
      cov_wb038vf15().b[5][0]++;
      cov_wb038vf15().s[14]++;
      return theme.colors.neutrals20;
    } else {
      cov_wb038vf15().b[5][1]++;
    }
  }
  cov_wb038vf15().s[15]++;
  return theme.colors.neutrals0;
};
cov_wb038vf15().s[16]++;
const getHeight = (isMulti, variant) => {
  cov_wb038vf15().f[3]++;
  const heightVariants = (cov_wb038vf15().s[17]++, {
    small: '36px',
    large: '54px'
  });
  cov_wb038vf15().s[18]++;
  return {
    height: isMulti ? (cov_wb038vf15().b[7][0]++, 'auto') : (cov_wb038vf15().b[7][1]++, heightVariants[variant]),
    minHeight: isMulti ? (cov_wb038vf15().b[8][0]++, '54px') : (cov_wb038vf15().b[8][1]++, 'unset')
  };
};
cov_wb038vf15().s[19]++;
const getSharedStyles = (theme, isInvalid, state, variant) => {
  cov_wb038vf15().f[4]++;
  cov_wb038vf15().s[20]++;
  return {
    border: "2px solid ".concat(getBorderColor(theme, isInvalid, state, variant)),
    boxShadow: 'none !important'
  };
};
cov_wb038vf15().s[21]++;
export const getSelectTheme = theme => {
  cov_wb038vf15().f[5]++;
  cov_wb038vf15().s[22]++;
  return _objectSpread(_objectSpread({}, theme), {}, {
    colors: _objectSpread(_objectSpread({}, theme.colors), {}, {
      danger: theme.colors.red50,
      primary: theme.colors.neutrals100,
      primary25: theme.colors.neutrals40
    })
  });
};
cov_wb038vf15().s[23]++;
export const getValueStyles = theme => {
  cov_wb038vf15().f[6]++;
  cov_wb038vf15().s[24]++;
  return {
    color: theme.colors.neutrals100,
    lineHeight: theme.lineHeights.s1,
    fontSize: theme.fontSizes.s1
  };
};
cov_wb038vf15().s[25]++;
const getVariantControlStyle = (theme, isInvalid, state, variant, paddingLevel) => {
  cov_wb038vf15().f[7]++;
  const paddingTB = (cov_wb038vf15().s[26]++, variant === 'small' ? (cov_wb038vf15().b[9][0]++, theme.space[2]) : (cov_wb038vf15().b[9][1]++, theme.space[3]));
  cov_wb038vf15().s[27]++;
  return _objectSpread({
    padding: paddingLevel === 'none' ? (cov_wb038vf15().b[10][0]++, 0) : (cov_wb038vf15().b[10][1]++, "".concat(paddingTB, " ").concat(theme.space[4])),
    textAlign: variant === 'small' ? (cov_wb038vf15().b[11][0]++, 'center') : (cov_wb038vf15().b[11][1]++, 'inherit'),
    backgroundColor: getBackgroundColor(theme, state, variant),
    '&:hover': {
      borderColor: isInvalid ? (cov_wb038vf15().b[12][0]++, theme.colors.red50) : (cov_wb038vf15().b[12][1]++, theme.colors.neutrals100),
      cursor: 'pointer'
    }
  }, getHeight(state.isMulti, variant));
};
cov_wb038vf15().s[28]++;
const getVariantMenuStyle = (theme, variant) => {
  cov_wb038vf15().f[8]++;
  cov_wb038vf15().s[29]++;
  if (variant === 'small') {
    cov_wb038vf15().b[13][0]++;
    cov_wb038vf15().s[30]++;
    return {
      marginTop: theme.space[3],
      borderRadius: theme.radii.roundedSquare
    };
  } else {
    cov_wb038vf15().b[13][1]++;
  }
  cov_wb038vf15().s[31]++;
  return {
    marginTop: "-".concat(theme.space[3]),
    borderTop: 'none',
    borderRadius: theme.radii.roundedSquare,
    borderTopRightRadius: theme.radii.none,
    borderTopLeftRadius: theme.radii.none
  };
};
cov_wb038vf15().s[32]++;
const getPlaceHolderStyle = (theme, state, variant) => {
  cov_wb038vf15().f[9]++;
  cov_wb038vf15().s[33]++;
  if (state.isDisabled) {
    cov_wb038vf15().b[14][0]++;
    cov_wb038vf15().s[34]++;
    return {
      color: theme.colors.neutrals70,
      fontWeight: variant === 'small' ? (cov_wb038vf15().b[15][0]++, theme.fontWeights.semibold) : (cov_wb038vf15().b[15][1]++, theme.fontWeights.normal)
    };
  } else {
    cov_wb038vf15().b[14][1]++;
    cov_wb038vf15().s[35]++;
    if (variant === 'small') {
      cov_wb038vf15().b[16][0]++;
      cov_wb038vf15().s[36]++;
      return {
        color: theme.colors.neutrals100,
        fontWeight: theme.fontWeights.semibold
      };
    } else {
      cov_wb038vf15().b[16][1]++;
    }
  }
  cov_wb038vf15().s[37]++;
  return {
    color: theme.colors.neutrals90
  };
};
cov_wb038vf15().s[38]++;
const getVariantOptionStyle = (theme, variant) => {
  cov_wb038vf15().f[10]++;
  cov_wb038vf15().s[39]++;
  if (variant === 'small') {
    cov_wb038vf15().b[17][0]++;
    cov_wb038vf15().s[40]++;
    return {
      height: '36px',
      textAlign: 'center',
      borderRadius: theme.radii.roundedSquare,
      padding: "".concat(theme.space[2], " ").concat(theme.space[4])
    };
  } else {
    cov_wb038vf15().b[17][1]++;
  }
  cov_wb038vf15().s[41]++;
  return {
    height: '54px',
    textAlign: 'left',
    padding: "".concat(theme.space[3], " ").concat(theme.space[4])
  };
};
cov_wb038vf15().s[42]++;
export const useSelectStyles = () => {
  cov_wb038vf15().f[11]++;
  const theme = (cov_wb038vf15().s[43]++, useTheme());
  cov_wb038vf15().s[44]++;
  return (isInvalid, variant, paddingLevel, overrides) => {
    cov_wb038vf15().f[12]++;
    cov_wb038vf15().s[45]++;
    return {
      container: (base, state) => {
        cov_wb038vf15().f[13]++;
        cov_wb038vf15().s[46]++;
        return _objectSpread(_objectSpread({}, base), {}, {
          width: '100%'
        }, overrides?.container ? (cov_wb038vf15().b[18][0]++, overrides.container(state)) : (cov_wb038vf15().b[18][1]++, {}));
      },
      control: (base, state) => {
        cov_wb038vf15().f[14]++;
        cov_wb038vf15().s[47]++;
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, base), getValueStyles(theme)), getSharedStyles(theme, isInvalid, state, variant)), getVariantControlStyle(theme, isInvalid, state, variant, paddingLevel)), {}, {
          borderRadius: theme.radii.roundedSquare,
          marginBottom: 0,
          marginTop: 0
        }, overrides?.control ? (cov_wb038vf15().b[19][0]++, overrides.control(state)) : (cov_wb038vf15().b[19][1]++, {}));
      },
      dropdownIndicator: (base, state) => {
        cov_wb038vf15().f[15]++;
        cov_wb038vf15().s[48]++;
        return _objectSpread(_objectSpread({}, base), {}, {
          paddingLeft: theme.space[1]
        }, overrides?.dropdownIndicator ? (cov_wb038vf15().b[20][0]++, overrides.dropdownIndicator(state)) : (cov_wb038vf15().b[20][1]++, {}));
      },
      valueContainer: (base, state) => {
        cov_wb038vf15().f[16]++;
        cov_wb038vf15().s[49]++;
        return _objectSpread(_objectSpread({}, base), {}, {
          padding: 0
        }, overrides?.valueContainer ? (cov_wb038vf15().b[21][0]++, overrides.valueContainer(state)) : (cov_wb038vf15().b[21][1]++, {}));
      },
      menu: (base, state) => {
        cov_wb038vf15().f[17]++;
        cov_wb038vf15().s[50]++;
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, base), getSharedStyles(theme, isInvalid, state, variant)), {}, {
          border: "2px solid ".concat(isInvalid ? (cov_wb038vf15().b[22][0]++, theme.colors.red50) : (cov_wb038vf15().b[22][1]++, theme.colors.neutrals100)),
          boxShadow: 'none !important',
          backgroundColor: theme.colors.neutrals0
        }, getVariantMenuStyle(theme, variant)), overrides?.menu ? (cov_wb038vf15().b[23][0]++, overrides.menu(state)) : (cov_wb038vf15().b[23][1]++, {}));
      },
      menuList: base => {
        cov_wb038vf15().f[18]++;
        cov_wb038vf15().s[51]++;
        return _objectSpread(_objectSpread({}, base), variant === 'small' ? (cov_wb038vf15().b[24][0]++, {
          padding: '0px'
        }) : (cov_wb038vf15().b[24][1]++, {}));
      },
      option: (base, state) => {
        cov_wb038vf15().f[19]++;
        cov_wb038vf15().s[52]++;
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, base), getValueStyles(theme)), getVariantOptionStyle(theme, variant)), {}, {
          color: getOptionColor(theme, state),
          backgroundColor: "".concat(state.isFocused ? (cov_wb038vf15().b[25][0]++, theme.colors.neutrals10) : (cov_wb038vf15().b[25][1]++, theme.colors.transparent)),
          '&:hover': {
            cursor: 'pointer'
          }
        }, overrides?.option ? (cov_wb038vf15().b[26][0]++, overrides.option(state)) : (cov_wb038vf15().b[26][1]++, {}));
      },
      placeholder: (base, state) => {
        cov_wb038vf15().f[20]++;
        cov_wb038vf15().s[53]++;
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, base), getValueStyles(theme)), {}, {
          margin: 0
        }, getPlaceHolderStyle(theme, state, variant)), overrides?.placeholder ? (cov_wb038vf15().b[27][0]++, overrides.placeholder(state)) : (cov_wb038vf15().b[27][1]++, {}));
      },
      // Single Select
      singleValue: (base, state) => {
        cov_wb038vf15().f[21]++;
        cov_wb038vf15().s[54]++;
        return _objectSpread(_objectSpread(_objectSpread({}, base), getValueStyles(theme)), overrides?.singleValue ? (cov_wb038vf15().b[28][0]++, overrides.singleValue(state)) : (cov_wb038vf15().b[28][1]++, {}));
      },
      // Multi Select
      multiValue: (base, state) => {
        cov_wb038vf15().f[22]++;
        cov_wb038vf15().s[55]++;
        return _objectSpread(_objectSpread(_objectSpread({}, base), getValueStyles(theme)), {}, {
          borderRadius: theme.radii.roundedSquare,
          padding: "".concat(theme.space[2], " ").concat(theme.space[4]),
          backgroundColor: theme.colors.neutrals30,
          marginRight: theme.space[2],
          fontWeight: theme.fontWeights.semibold,
          height: '36px'
        }, overrides?.multiValue ? (cov_wb038vf15().b[29][0]++, overrides.multiValue(state)) : (cov_wb038vf15().b[29][1]++, {}));
      },
      multiValueLabel: (base, state) => {
        cov_wb038vf15().f[23]++;
        cov_wb038vf15().s[56]++;
        return _objectSpread(_objectSpread(_objectSpread({}, base), getValueStyles(theme)), {}, {
          padding: 0,
          paddingLeft: 0,
          margin: 0
        }, overrides?.multiValueLabel ? (cov_wb038vf15().b[30][0]++, overrides.multiValueLabel(state)) : (cov_wb038vf15().b[30][1]++, {}));
      },
      multiValueRemove: (base, state) => {
        cov_wb038vf15().f[24]++;
        cov_wb038vf15().s[57]++;
        return _objectSpread(_objectSpread(_objectSpread({}, base), getValueStyles(theme)), {}, {
          color: theme.colors.neutrals90,
          marginLeft: theme.space[2],
          fontWeight: theme.fontWeights.semibold,
          '&:hover': {
            backgroundColor: 'inherit',
            color: theme.colors.neutrals100,
            fontWeight: theme.fontWeights.bold
          }
        }, overrides?.multiValueRemove ? (cov_wb038vf15().b[31][0]++, overrides.multiValueRemove(state)) : (cov_wb038vf15().b[31][1]++, {}));
      },
      indicatorSeparator: (base, state) => {
        cov_wb038vf15().f[25]++;
        cov_wb038vf15().s[58]++;
        return _objectSpread(_objectSpread({}, base), {}, {
          backgroundColor: 'none'
        }, overrides?.indicatorSeparator ? (cov_wb038vf15().b[32][0]++, overrides.indicatorSeparator(state)) : (cov_wb038vf15().b[32][1]++, {}));
      }
    };
  };
};